import api from "./api";
const svc = {
  listar:      (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/comunicados?${qs}`); },
  buscarPorId: id     => api("GET",`/comunicados/${id}`),
  criar:       data   => api("POST","/comunicados",data),
  atualizar:   (id,data) => api("PUT",`/comunicados/${id}`,data),
  deletar:     id     => api("DELETE",`/comunicados/${id}`),
  marcarLido:  (id,data) => api("POST",`/comunicados/${id}/lido`,data),
  naoLidos:    (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/comunicados/nao-lidos?${qs}`); },
  estatisticas: id    => api("GET",`/comunicados/${id}/estatisticas`),
  reenviar:    id     => api("POST",`/comunicados/${id}/reenviar`,{}),
  listarAnexos:  (id)    => api("GET",`/comunicados/${id}/anexos`),
  uploadAnexo:  (id,data) => api("POST",`/comunicados/${id}/anexos`,data),
  deletarAnexo: (id,aid)  => api("DELETE",`/comunicados/${id}/anexos/${aid}`),
  downloadAnexo:(id,aid)  => api("GET",`/comunicados/${id}/anexos/${aid}`),
};
export default svc;
